import script from "./DashBoardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBoardPage.vue?vue&type=script&setup=true&lang=js"

import "./DashBoardPage.vue?vue&type=style&index=0&id=44579a50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44579a50"]])

export default __exports__